import React from "react";
import Tooltip from "./Tooltip";
import { getIcon } from "utils/iconsConfig";
import { useGlobalContext } from "context/GlobalContext";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";

/* -------------------- REUSABLE ICON BOX -------------------- */

const TooltipIcon = ({ item }) => (
  <Tooltip title={item.tooltip} arrow>
    <div
      style={{
        display: "flex",
        gap: "25px",
        alignItems: "center",
      }}
    >
    <div
      style={{
        // width: "40px",
        // height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      {getIcon(item.icon)}

      <span
        style={{
          color: "#fff",
          fontSize: "16px",
          padding: "2px 6px",
          minWidth: "18px",
          textAlign: "center",
          fontFamily: "Poppins",
          fontWeight: 500,
        }}
      >
        {item.count}
      </span>
    </div>
    </div>
  </Tooltip>
);

/* -------------------- MAIN COMPONENT -------------------- */

const ServiceRequestIconChild = () => {

  const { serviceRequestCounts } = useGlobalContext();
  const permission = usePermissions();
  const serviceRequestsSubMenu = findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Service Requests");
  const showStatusProduction = isAllowed(serviceRequestsSubMenu, "status");
  
  const { byStatus = {}, byServiceType = {} } = serviceRequestCounts;

  /* -------------------- DEMO DATA -------------------- */

const statusData = [
  {
    tooltip: "Review",
    count: byStatus.Review || 0,
    bgColor: "#1F6FEB",
    icon: "ReviewIcon",
  },
  {
    tooltip: "Accepted",
    count: byStatus.Accepted || 0,
    bgColor: "#F0B90B",
    icon: "AcceptedIcon",
  },
  {
    tooltip: "Received",
    count: byStatus.Received || 0,
    bgColor: "#8C50C81A",
    icon: "PurpleReceivedNewIcon",
  },
  {
    tooltip: "Production",
    count: byStatus.Production || 0,
    bgColor: "#2EA043",
    icon: "ProductionIcon",
  },
  {
    tooltip: "Need Your Approval",
    count: byStatus["Need your Approval"] || 0,
    bgColor: "#DB61A2",
    icon: "NeedYourApprovalIcon",
  },
  {
    tooltip: "Ready for Dispatch",
    count: byStatus["Ready for Dispatch"] || 0,
    bgColor: "#58A6FF",
    icon: "ReadyForDispatchIcon",
  },
  {
    tooltip: "Dispatched",
    count: byStatus.Dispatched || 0,
    bgColor: "#8B949E",
    icon: "DispatchedIcon",
  },
  {
    tooltip: "Cancelled",
    count: byStatus.Cancelled || 0,
    bgColor: "#E77B7B1A",
    icon: "CancelledReceiveIcon",
  }
];

const typeData = [
  {
    tooltip: "Repairing Request",
    count: byServiceType["Repairing Request"] || 0,
    bgColor: "#E5533D",
    icon: "RepairingRequestIcon",
  },
  {
    tooltip: "QC Failed",
    count: byServiceType["QC Failed"] || 0,
    bgColor: "#D29922",
    icon: "QcFailedIcon",
  },
  {
    tooltip: "Manufacturing Defects",
    count: byServiceType["Manufacturing Defects"] || 0,
    bgColor: "#DB6D28",
    icon: "ManufacturingDefectsIcon",
  },
];

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "15px"
      }}
    >
      {/* STATUS */}
      {showStatusProduction && (
        <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px", background: "#0D0D0D", borderRadius: "5px" }}>
          <span style={{ color: "#fff", fontSize: "16px", fontWeight: 500, fontFamily: "Poppins" }}>Status :</span>

          {statusData.map((item, index) => (
            <TooltipIcon key={index} item={item} />
          ))}
        </div>
      )}

      {/* TYPE */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px", background: "#0D0D0D", borderRadius: "5px" }}>
        <span style={{ color: "#fff", fontSize: "16px", fontWeight: 500, fontFamily: "Poppins" }}>Type :</span>

        {typeData.map((item, index) => (
          <TooltipIcon key={index} item={item} />
        ))}
      </div>
    </div>
  );
};

export default ServiceRequestIconChild;
